import { useCartContext } from '../../context/CartContext';
import { useUserContext } from '../../context/UserContext';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { StyledBadge } from '../../components/useStyles';
import { cartActionTypes, userTypes } from '../../app/enums';
import { Fab }from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    toolbarTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
    },
  }),
);

export const Cart = () => {
  const classes = useStyles();
  const { state, dispatch } = useCartContext();
  const user = useUserContext();

  const toggleDrawer = () => {
    dispatch({type:cartActionTypes.TOGGLE_CART});
  };

  if(user.state.self.userType !== userTypes.EXTERNAL){
    return (<div></div>);
  }

  return (
    <>
      <div className={classes.toolbarTitle}>
        <Fab 
          aria-label="Cart" 
          color="primary" 
          onClick={() => toggleDrawer()}
        >
          <StyledBadge badgeContent={state.itemCount} color="secondary">
            <ShoppingCartIcon style={{ fontSize: 25 , color: 'inherit' }} />
          </StyledBadge>
        </Fab>
      </div>
    </>
  );
}

export default Cart;
